const CollapsedLogoIcon = () => {
  return (
    <svg width="62" height="37" viewBox="0 0 62 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8363_4680)">
        <mask id="mask0_8363_4680" maskUnits="userSpaceOnUse" x="0" y="0" width="62" height="37">
          <path d="M61.8922 0.615234H0.107666V36.3852H61.8922V0.615234Z" fill="white" />
        </mask>
        <g mask="url(#mask0_8363_4680)">
          <path d="M0.107666 0.618652L20.7892 36.3854H29.0579L8.37638 0.618652H0.107666Z" fill="#FD5403" />
          <mask id="mask1_8363_4680" maskUnits="userSpaceOnUse" x="0" y="0" width="62" height="37">
            <path d="M61.8922 0.615234H0.107666V36.3852H61.8922V0.615234Z" fill="white" />
          </mask>
          <g mask="url(#mask1_8363_4680)">
            <path
              d="M44.2595 9.41007C44.2595 9.97151 44.2075 10.52 44.1068 11.0522C43.577 13.827 41.7471 16.1441 39.2736 17.3319C38.1165 17.8934 36.8229 18.2049 35.4513 18.2049H30.6149L41.1295 36.3885H32.8608L18.215 11.0522L35.4513 11.0425C36.3581 11.0425 37.0927 10.3123 37.0927 9.40358C37.0927 8.49489 36.3581 7.76469 35.4513 7.76469H16.3136L12.176 0.615234H35.4545C37.7167 0.615234 39.7806 1.46551 41.3408 2.86749C42.7449 4.12668 43.7427 5.83372 44.1068 7.76469C44.2108 8.29368 44.2628 8.84538 44.2628 9.41007"
              fill="#FD5403"
            />
            <path d="M61.8924 0.615234L42.9725 33.3346L38.8381 26.1884L53.6236 0.615234H61.8924Z" fill="#FD5403" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8363_4680">
          <rect width="61.7845" height="35.77" fill="white" transform="translate(0.107666 0.615234)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CollapsedLogoIcon;
